import { statusFeed } from '@/mocks/home';
import StatusPill from './StatusPill';

export default function StatusFeed() {
  return (
    <section id="status" className="scroll-mt-20 bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div className="lg:col-span-4">
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600">访问状态</span>
            <h2 className="mt-3 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-4xl">
              线路快讯
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              这里记录官网最近的访问状态与地址变化。打不开之前，先看一眼这条时间线，往往就知道该怎么做。
            </p>
            <a
              href="#addresses"
              className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors duration-200 hover:text-primary-700"
            >
              查看当前可用地址
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative space-y-8 border-l border-background-300 pl-6 md:pl-8">
              {statusFeed.map((item) => (
                <li key={`${item.date}-${item.time}`} className="relative">
                  <span
                    className={`absolute -left-[31px] top-2 h-3.5 w-3.5 rounded-full border-2 border-background-100 md:-left-[39px] ${
                      item.tone === 'ok'
                        ? 'bg-secondary-500'
                        : item.tone === 'warn'
                          ? 'bg-accent-500'
                          : 'bg-foreground-400'
                    }`}
                  ></span>
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-heading text-base font-bold text-foreground-900">
                      {item.time}
                    </span>
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <StatusPill label={item.tag} tone={item.tone} dot={false} />
                  </div>
                  <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}